export default __webpack_public_path__ + "static/media/arrow-up.ab50be03.svg";